module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFAAAABQBAMAAAB8P++eAAAAHlBMVEUAAACk1P10vvnV6/91vvrE4f/b7v/V6/9ktPdwufi1E+alAAAABXRSTlMA0N6vvIhg+JMAAABKSURBVEjHYxgFIw2E4gGjCkcVjiocVTiqcFThqEIkUI4HoChMwwMGo8LMjo5pRClMLy8vo6MbjY0FcQBjYwZU4KSEFagwjIIRBwBLFw8fUYBRlwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home/sub/30.xiaofang.png
// module id = 809
// module chunks = 1